import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import apiCall from "../../api/api-call";
import Util from "../../util/util";

function CategoryBox() {
  const [jobPost, setJobPost] = useState([]);
  const [postByCat, setPostByCat] = useState([]);

  useEffect(() => {
    apiCall
      .getAllJobList()
      .then((response) => {
        //console.log("response: ", response);
        setJobPost(response.data.response.Items);
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }, []);

  useEffect(() => {
    const result = jobPost.reduce((r, a) => {
      r[a.category] = r[a.category] || [];
      r[a.category].push(a);
      return r;
    }, {});

    //console.log("result: ", result);
    setPostByCat(result);
  }, [jobPost]);

  useEffect(() => {
    Util.getJobCategoryList().forEach((category) => {
      const vacancyElem = document.querySelector(
        `[aria-label="${category} vacancy"]`
      );
      const vacancyCount = postByCat[category] ? postByCat[category].length : 0;

      vacancyElem.textContent = vacancyCount;
    });
  }, [postByCat]);

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          Explore By Category
        </h1>
        <div className="row g-4">
          {Util.getJobCategoryListWithIcon().map((category, index) => (
            <div
              key={index}
              className="col-lg-3 col-sm-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <NavLink
                to={`/job-list/${category.name}`}
                className="cat-item rounded p-4"
              >
                <i
                  className={`fa fa-3x ${category.icon} text-primary mb-4`}
                ></i>
                <h6 className="mb-3" aria-label={category.name}>
                  {category.name}
                </h6>
                <p className="mb-0">
                  <span aria-label={`${category.name} vacancy`}>0</span> Job
                  Post
                </p>
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoryBox;
